@if (visible()) {
  <button
    mat-button
    class="org-switcher"
    [matMenuTriggerFor]="orgMenu"
    [disabled]="disabled()"
    aria-label="Switch organisation"
  >
    <mat-icon>business</mat-icon>
    <span class="org-switcher__name">{{ currentName() }}</span>
    <mat-icon class="org-switcher__caret">arrow_drop_down</mat-icon>
  </button>
  <mat-menu #orgMenu="matMenu">
    @for (org of organisations(); track org.id) {
      <button
        mat-menu-item
        [disabled]="disabled() || org.id === currentOrgId()"
        (click)="switch(org.id)"
      >
        @if (org.id === currentOrgId()) {
          <mat-icon>check</mat-icon>
        } @else {
          <mat-icon>business</mat-icon>
        }
        <span>{{ org.name }}</span>
      </button>
    }
  </mat-menu>
}
